import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'particle-copy-filing-dialog',
  templateUrl: './copy-filing-dialog.component.html',
  styleUrls: ['./copy-filing-dialog.component.scss']
})
export class CopyFilingDialogComponent implements OnInit, IDialogView {
  inputForm: any;
  inputFormErrors: any;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      isArchive  : [true],
      isResubmit  : [false],
      title  : [this.data.input['title'], Validators.required]
    });
    this.inputForm.valueChanges.subscribe(formValue=>{
      this.onFormValuesChanged();
    });
  }
  onFormValuesChanged() {
    for (const field in this.inputFormErrors) {
      if (!this.inputFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormErrors[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormErrors[field] = control.errors;
      }
    }
    this.data.isDisabledOkButton = !this.inputForm.valid;
  }
  data: DialogModel;

  onOkClicked(): boolean {
    this.data.input['isArchive'] = this.inputForm.controls['isArchive'].value;
    this.data.input['title'] = this.inputForm.controls['title'].value;
    return true;
  }

}
